import React, { useEffect, useMemo, useState, useCallback } from "react";
import { get, map, reduce } from "lodash";
import { Button } from "primereact/button";
import { Title } from "components/Title";
import useAuth from "hooks/useAuth";
import useApi from "hooks/useApi";
import { useTranslation } from 'react-i18next';

export const ingestionBody = [
  {
    label: "action",
    type: "string",
    description: "Description of the action taken.",
    sampleVal: "Cancer Awareness Events",
  },
  {
    label: "channel",
    type: "string",
    description: "Channel of the event.",
    sampleVal: "In-person",
  },
  {
    label: "details",
    type: "string",
    description: "Details of the event.",
    sampleVal: "Patient discharged from the hospital.",
  },
  {
    label: "dr_name",
    type: "string",
    description: "Name of the doctor involved.",
    sampleVal: "Dr. Anderson",
  },
  {
    label: "encounter_number",
    type: "string",
    description: "Encounter number.",
    sampleVal: "ENC246810",
  },
  {
    label: "event_time",
    type: "string <date-time>",
    description: "Timestamp of the event.",
    sampleVal: "2024-01-05T14:45:00",
  },
  {
    label: "location",
    type: "string",
    description: "Location of the event.",
    sampleVal: "Discharge Lounge",
  },
  {
    label: "module_code",
    type: "string",
    description: "Code of the module.",
    sampleVal: "RAD1",
  },
  {
    label: "mrn",
    type: "string",
    description: "Medical Record Number.",
    sampleVal: "MRN789",
  },
  {
    label: "organisation_code",
    type: "string",
    description: "Code of the organization.",
    sampleVal: "ORG2",
  },
  {
    label: "personnel_contact",
    type: "string",
    description: "Contact number of the personnel.",
    sampleVal: "+3698521470",
  },
  {
    label: "personnel_gender",
    type: "string",
    description: "Gender of the personnel.",
    sampleVal: "male",
  },
  {
    label: "personnel_details",
    type: "string",
    description: "Details of the personnel.",
    sampleVal: "Some perssonel data.",
  },
  {
    label: "personnel_name",
    type: "string",
    description: "Name of the personnel.",
    sampleVal: "clark kent",
  },
  {
    label: "personnel_role",
    type: "string",
    description: "Role of the personnel.",
    sampleVal: "Discharge Staff",
  },
  {
    label: "personnel_tags",
    type: "string",
    description: "Tags associated with the personnel.",
    sampleVal: "discharge,planner",
  },
  {
    label: "queue_number",
    type: "string",
    description: "Queue number.",
    sampleVal: "Q789",
  },
  {
    label: "investigation",
    type: "string",
    description: "Investigation Flow",
    sampleVal: "inv12",
  },
  {
    label: "patient_type",
    type: "string",
    description: "Patient Type i.e. In or Out",
    sampleVal: "inpatient",
  },
  {
    label: "patient_referrals",
    type: "string",
    description: "patient_referrals",
    sampleVal: "Patient Referrals",
  },
];
export function RequestBody  (props){
  const{setShowCURL, copyIconClass3, ingestionBody, showCURL, setCopyIconClass3, ingestionUrl, token}=props;
 const {t}=useTranslation();
  return (t,
    <div
      style={{
        height: "105%",
      }}
    >
      <div className="flex">
        <Title
          title={t("REQUEST_SAMPLE")}
          titleClass="text-xl"
          subTitleClass="text-900"
          separator={false}
        />
        <i
          className={copyIconClass3}
          style={{
            fontSize: "2rem",
            marginLeft: "10px",
            color: "var(--gray-400)",
            cursor: "pointer",
          }}
          onClick={() => {
            const ingestionObjStr = reduce(
              ingestionBody,
              (str, item, index) => {
                str += `"${item.label}" : "${item.sampleVal}"`;
                if (index !== ingestionBody.length - 1) {
                  str += ",\n";
                }
                return str;
              },
              ""
            );
            const jsonSample = `[{\n${ingestionObjStr}\n}]`;
            let copiedText = "";
            if (showCURL) {
              copiedText = "curl -X POST \\\n";
              copiedText += ingestionUrl + "\\\n";
              copiedText +=
                "-H 'Content-Type: application/json' \\\n";
              copiedText += `-H 'Authorization: ${
                token ? token : "{token}"
              }' \\\n`;
              copiedText += "-d '";
              copiedText += jsonSample;
              copiedText += "'";
            } else {
              copiedText = jsonSample;
            }
            navigator.clipboard.writeText(copiedText);
            setCopyIconClass3("pi pi-check");
            setTimeout(
              () => setCopyIconClass3("pi pi-clone"),
              1000
            );
          }}
        />
      </div>
      <div className="flex mb-3">
        <Button
          label="JSON"
          type="button"
          className={
            "p-button selection-btn" +
            (!showCURL ? " focus" : "")
          }
          onClick={() => setShowCURL(false)}
        />
        <Button
          label="cURL"
          type="button"
          className={
            "p-button ml-2 selection-btn" +
            (showCURL ? " focus" : "")
          }
          onClick={() => setShowCURL(true)}
        />
      </div>
      <div
        className="card"
        style={{
          backgroundColor: "var(--surface-200)",
        }}
      >
        {showCURL && (
          <>
            <div className="font-bold">
              {"curl -X POST \\"}
            </div>
            <div className="font-bold ml-2">
              {ingestionUrl + " \\"}
            </div>
            <div className="font-bold ml-2">
              {"-H "}
              <span
                style={{
                  color: "var(--primary-color)",
                }}
              >
                {"'Content-Type: application/json'"}
              </span>
              {" \\"}
            </div>
            <div className="font-bold ml-2">
              {"-H "}
              <span
                style={{
                  color: "var(--primary-color)",
                }}
              >
                {`'Authorization: ${
                  token ? token : "{token}"
                }'`}
              </span>
              {" \\"}
            </div>
          </>
        )}
        <div className="mb-1">
          {showCURL && (
            <>
              <span className="font-bold ml-2">
                {"-d"}
              </span>
              <span
                className="font-bold ml-2"
                style={{
                  color: "var(--primary-color)",
                }}
              >
                {"'"}
              </span>
            </>
          )}

          <span
            className={
              "font-bold" + (showCURL ? " ml-1" : "")
            }
            style={{
              color: "var(--primary-color)",
            }}
          >
            {"[ {"}
          </span>
        </div>
        {map(ingestionBody, (item) => {
          return (
            <div
              className={
                "mb-1 flex" + (showCURL ? " ml-5" : "")
              }
            >
              <div
                className="font-bold"
                style={{
                  color: "var(--primary-color)",
                }}
              >
                {'"' + item.label + '" :'}
              </div>
              <div
                className="font-bold ml-1"
                style={{
                  color: "var(--primary-color)",
                }}
              >
                {'"' + item.sampleVal + '"'}
              </div>
            </div>
          );
        })}
        <div
          className={"mb-1" + (showCURL ? " ml-5" : "")}
        >
          <span
            className="font-bold"
            style={{
              color: "var(--primary-color)",
            }}
          >
            {"} ]"}
          </span>
          {showCURL && (
            <span
              className="font-bold"
              style={{
                color: "var(--primary-color)",
              }}
            >
              {" '"}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
const IngestionApiPage = (props) => {
  const auth = useAuth();
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [token, setToken] = useState(null);
  const [copyIconClass, setCopyIconClass] = useState("pi pi-clone");
  const [copyIconClass2, setCopyIconClass2] = useState("pi pi-clone");
  const [copyIconClass3, setCopyIconClass3] = useState("pi pi-clone");
  const [show, setShow] = useState("200");
  const [showCURL, setShowCURL] = useState(false);
  const ingestionUrl = useMemo(() => {
    const apiPath = process.env.REACT_APP_API_PATH || "/api/";
    let fullUrl;
    if (apiPath.startsWith("http")) {
      fullUrl = `${apiPath}es/ingest/event`;
    } else {
      const baseUrl = window.location.origin;
      fullUrl = `${baseUrl}${apiPath.endsWith("/") ? apiPath : `${apiPath}/`}es/ingest/event`;
    }
    return fullUrl;
  }, []);

  useEffect(() => {
    setLoading(true);
    api
      .get(`es/get_token/${auth.user.user}`)
      .then((res) => {
        const tokenData = get(res, "data.token");
        if (tokenData) {
          setToken(tokenData);
        } else {
          setToken(null);
        }
        setLoading(false);
      })
      .catch((e) => {
        setToken(null);
        setLoading(false);
      });
  }, []);
  const{t}=useTranslation();
  const generateToken = useCallback(() => {
    setGenerating(true);
    api
      .post("es/generate_token", {
        username: auth.user.user,
      })
      .then((res) => {
        const tokenData = get(res, "data.token");
        if (tokenData) {
          setToken(tokenData);
        } else {
          setToken(null);
        }
        setGenerating(false);
      })
      .catch((e) => {
        setToken(null);
        setGenerating(false);
      });
  }, []);

  const tokenSection = useMemo(() => {
    if (loading) {  
      return <span className="text-800 font-medium mb-1">{t("LOADING")}</span>;
    } else if (token) {   
      return (
        <div>
          <Title
            title={t("TOKEN")}
            titleClass="text-2xl font-bold"
            subTitleClass="text-500"
            separator={false}
          />
          <div className="flex align-items-center">
            <span
              className="text-900 text-xl font-medium mb-1 card"
              style={{
                backgroundColor: "var(--surface-200)",
              }}
            >
              {token}
            </span>
            <i
              className={copyIconClass}
              style={{
                fontSize: "2.5rem",
                marginLeft: "10px",
                color: "var(--gray-400)",
                cursor: "pointer",
              }}
              onClick={() => {
                navigator.clipboard.writeText(token);
                setCopyIconClass("pi pi-check");
                setTimeout(() => setCopyIconClass("pi pi-clone"), 1000);
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <Button
          label={generating ? t("GENERATING") : t('GENERATE_TOKEN')}
          type="button"
          className="p-button bg-primary"
          onClick={generateToken}
        />
      );
    }
  }, [loading, generating, token, copyIconClass]);

  return (t,
    <div>
      <main id="IngestionApiPage" className="main-page">
        <section className="page-section mb-3">
          <div className="container">
            <div className="grid align-items-center">
              <div className="col ">
                <Title
                  title={t("INGESTION_API")}
                  titleClass="text-2xl text-primary font-bold"
                  subTitleClass="text-900"
                  separator={false}
                />
              </div>
            </div>
          </div>
        </section>
        <section className="page-section ">
          <div className="container">
            <div className="grid ">
              <div className="col comp-grid">
                <div>
                  <div className="mb-3 grid justify-content-start">
                    <div className="col-12">{tokenSection}</div>
                    <div className="col-12">
                      <Title
                        title={t("INGEST_EVENT_DOCUMENTATION")}
                        titleClass="text-2xl font-bold"
                        subTitleClass="text-500"
                        separator={false}
                      />
                      <div className="mb-4">
                        <span>
                         {t("PARA")}
                        </span>
                      </div>
                      <div className="mb-4">
                        <Title
                          title="API URL :"
                          titleClass="text-xl"
                          subTitleClass="text-900"
                          separator={false}
                        />
                        <div className="flex align-items-center">
                          <div
                            className="card bg-primary"
                            style={{
                              padding: "8px",
                              width: "50px",
                            }}
                          >
                            {t("POST")}
                          </div>
                          <span className="text-900 text-xl font-medium ml-2">
                            {ingestionUrl}
                          </span>
                          <i
                            className={copyIconClass2}
                            style={{
                              fontSize: "2.5rem",
                              marginLeft: "10px",
                              color: "var(--gray-400)",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigator.clipboard.writeText(ingestionUrl);
                              setCopyIconClass2("pi pi-check");
                              setTimeout(
                                () => setCopyIconClass2("pi pi-clone"),
                                1000
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-4">
                        <Title
                          title={t("REQUEST_HEADER")}
                          titleClass="text-xl"
                          subTitleClass="text-900"
                          separator={false}
                        />
                        <div className="card col-8">
                          <div className="mb-1">
                            <span className="text-400 font-medium">
                              {t("CONTENT_TYPE")}
                            </span>
                            <span
                              className="font-bold"
                              style={{
                                marginLeft: "20px",
                              }}
                            >
                              {t("APPLICATION")}
                            </span>
                          </div>
                          <div>
                            <span className="text-400 font-medium">
                              {t("AUTHORIZATION")}
                            </span>
                            <span
                              className="font-bold"
                              style={{
                                marginLeft: "20px",
                              }}
                            >
                              {token ? token : "{Token}"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex">
                        <div className="col-5">
                          <Title
                            title={t("REQUEST_BODY")}
                            titleClass="text-xl"
                            subTitleClass="text-900"
                            separator={false}
                          />
                          <div className="card">
                            <div className="mb-1">
                              <span className="text-400 font-medium">
                                {"Array [ {"}
                              </span>
                            </div>
                            {map(ingestionBody, (item) => {
                              return (
                                <div className="mb-1 flex">
                                  <div
                                    className="text-400 font-medium"
                                    style={{
                                      width: "140px",
                                    }}
                                  >
                                    {item.label}
                                  </div>
                                  <div className="flex flex-column">
                                    <span className="">{item.type}</span>
                                    <span className="font-bold">
                                      {item.description}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                            <div className="mb-1">
                              <span className="text-400 font-medium">
                                {"} ]"}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-column col-7 ml-3">
                          <RequestBody setShowCURL={setShowCURL} copyIconClass3={copyIconClass3} ingestionBody={ingestionBody} showCURL={showCURL} setCopyIconClass3={setCopyIconClass3} ingestionUrl={ingestionUrl} token={token} />
                          <div
                            style={{
                              height: "27%",
                              marginTop: "20px",
                            }}
                          >
                            <Title
                              title={t("RESPONSE_SAMPLES")}
                              titleClass="text-xl"
                              subTitleClass="text-900"
                              separator={false}
                            />
                            <div className="flex mb-3">
                              <Button
                                label="200"
                                type="button"
                                className={
                                  "p-button btn-success" +
                                  (show === "200" ? " focus" : "")
                                }
                                onClick={() => setShow("200")}
                              />
                              <Button
                                label="404"
                                type="button"
                                className={
                                  "p-button ml-2 btn-failure" +
                                  (show === "404" ? " focus" : "")
                                }
                                onClick={() => setShow("404")}
                              />
                            </div>
                            <div
                              className="card"
                              style={{
                                backgroundColor: "var(--surface-200)",
                              }}
                            >
                              <div className="mb-1">
                                <span className="font-bold">{"{"}</span>
                              </div>
                              <div className="mb-1 flex">
                                <div className="font-bold">{'"message" :'}</div>
                                <div
                                  className="font-bold ml-1"
                                  style={{
                                    color: "var(--primary-color)",
                                  }}
                                >
                                  {'"string"'}
                                </div>
                              </div>
                              {show === "404" && (
                                <div className="mb-1 flex">
                                  <div className="font-bold">{'"code" :'}</div>
                                  <div
                                    className="font-bold ml-1"
                                    style={{
                                      color: "var(--primary-color)",
                                    }}
                                  >
                                    {"0"}
                                  </div>
                                </div>
                              )}
                              <div className="mb-1">
                                <span className="font-bold">{"}"}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};
 
export default IngestionApiPage;